import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import TextInput from 'components/form/TextInput'
import ErrorText from 'components/form/ErrorText'
import { setName } from '../campaignSlice'
import { trimValue } from '../../../../utils'

const CampaignName = ({ error }) => {
  const dispatch = useDispatch()
  const { name } = useSelector(state => state.ad.campaign.form)
  const handleChange = useCallback(
    value => dispatch(setName(trimValue(value))),
    [dispatch]
  )
  return (
    <div className={classNames('area_item', { error })}>
      <strong className="subtit_box">캠페인 이름</strong>
      <div className="cont_card">
        <TextInput
          placeholder="캠페인 이름을 입력하세요."
          name="name"
          maxLength={50}
          value={name}
          onValueChange={handleChange}
          error={error}
        />
        <ErrorText error={error} tag="p" />
      </div>
    </div>
  )
}
CampaignName.propTypes = {
  error: PropTypes.string,
}

export default CampaignName
